import React, {useEffect, useState} from 'react'

import {CategorieItem} from "./CategorieItem";
import {MdExpandLess} from "@react-icons/all-files/md/MdExpandLess";
import {MdExpandMore} from "@react-icons/all-files/md/MdExpandMore";

import {useTekstClient} from "hooks/useTekstClient";
import {useAxios} from "hooks/useAxios";
import {useSetSearchParams} from "hooks/useSetSearchParams";
import {useSearchParams} from 'next/navigation'
import useGebruiker from "hooks/useGebruiker";
import useSWR from "swr";


const useFetchCategorieen = () => {
    const {get} = useAxios();
    return useSWR(['/wiki/categorieen?hasWiki=1'], ([url]) =>
            get(url)
                .then(res => res.data)
                .catch(error => {
                    if (error.response.status !== 409) throw error;
                }), {
            refreshInterval: 0,
            revalidateIfStale: false,
            revalidateOnReconnect: true,
            revalidateOnFocus: false,
        }
    );
};


export const FilterCategorieen = () => {
    const {get} = useAxios()
    const searchParams = useSearchParams();
    const [expand, setExpand] = useState(true);
    const [urlParamsLoading, setUrlParamsLoading] = useState(false);
    //const [categorieen, setCategorieen] = useState(true);
    const [toonMeer, setToonMeer] = useState(!!searchParams.get('cat'));
    const {tekst} = useTekstClient()

    const catId = searchParams.get('cat') ? parseInt(searchParams.get('cat')) : null
    const menuId = searchParams.get('menu') ? searchParams.get('menu') : null
    const docId = searchParams.get('doc') ? parseInt(searchParams.get('doc')) : null
    const subDocId = searchParams.get('subdoc') ? parseInt(searchParams.get('subdoc')) : null
    const { deleteParam, updateParam, doMultipleChanges } = useSetSearchParams()
    const {ingelogdeGebruiker} = useGebruiker()
    const {
        data: categorieen,
    } = useFetchCategorieen('/wiki/categorieen?hasWiki=1', ingelogdeGebruiker);


    const _checkIdExistsInNestedArray = (id = null, dataArray) => {
        for (const item of dataArray) {
            if (item.id === id || (item.menu_id && item.menu_id.includes(menuId)) || (item.doc_id && 
              item.doc_id === (docId || subDocId))) {
                return true;
            }
            if (item.children_recursive_has_wiki_kenniscentrum && 
              item.children_recursive_has_wiki_kenniscentrum.length > 0) {
                if (_checkIdExistsInNestedArray(id, item.children_recursive_has_wiki_kenniscentrum)) {
                    return true;
                }
            }
        }
        return false;
    }

    /**
     * From the software application there can be set some parameters that we convert to a category
     * If this is the case, we always accept a menu param in combinations with doc or/and subdoc
     * First menu with subdoc is being searched,
     * of noting is found than menu with doc,
     * and after that only menu is being searched
     * Only 1 cotegorie will be returned
     */
    useEffect(() => {
        if (!urlParamsLoading && menuId && (docId || subDocId)) {
            setUrlParamsLoading(true) // make sure this only runs once
            let url = '';
            if (menuId) url = 'menu=' + menuId;
            if (docId) url += (url.length > 0 ? '&': '') + 'doc=' + docId;
            if (subDocId) url += (url.length > 0 ? '&': '') + 'subdoc=' + subDocId;
            get(`/wiki/categorieen/findcat?${url}`).then((result) => {
                if (result.data?.id) {
                    doMultipleChanges([
                        {fun: 'setParams', params: [{name: 'cat', value: result.data?.id}]},
                        {fun: 'deleteParam', params: 'menu'},
                        {fun: 'deleteParam', params: 'doc'},
                        {fun: 'deleteParam', params: 'subdoc'}
                    ])
                } else {
                    // no result, make sure we don't get an endless loop
                    doMultipleChanges([
                        {fun: 'deleteParam', params: 'menu'},
                        {fun: 'deleteParam', params: 'doc'},
                        {fun: 'deleteParam', params: 'subdoc'}
                    ])
                }
            }).finally()// we are not setting setUrlParamsLoading(false) 
            // because if something go's wrong with will create an endless loop
        }
    }, [menuId])


    return <div>
        {categorieen && <>
            <b className={`flex items-center cursor-pointer`} onClick={() => setExpand(!expand)}>
                {expand
                    ? <MdExpandLess />
                    : <MdExpandMore />
                }
                {tekst('pagina:support:kenniscentrum:categorie:titel')}
            </b>
            {expand && categorieen &&
                <div className={'ml-3'}>
                    {categorieen.length > 0 && categorieen.map((cat, i) => {
                        return (i < 4 || toonMeer) &&
                            <CategorieItem
                                catToShow={catId}
                                key={cat.id}
                                categorie={cat}
                                updateParam={updateParam}
                                deleteParam={deleteParam}
                            />
                    })}

                    {categorieen?.length > 4
                        ? toonMeer
                            ? <div onClick={() => {
                                setToonMeer(false)
                            }} className={`flex items-center cursor-pointer`}>
                                {tekst('algemeen:searchbar:Minder')} <MdExpandLess/>
                            </div>
                            : <div onClick={() => {
                                setToonMeer(true)
                            }} className={`flex items-center cursor-pointer`}>
                                {tekst('algemeen:searchbar:Meer')} <MdExpandMore/>
                            </div>
                        : <></>
                    }

                </div>
            }
            <div className={`border-b border-kleur-licht-grijs-blauw pb-[20px] mb-[20px]`}/>
        </>}
    </div>
}